"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var trustedDomain_1 = require("@common/services/trustedDomain");
var linkUtils_1 = require("@utils/linkUtils");
var SecurityWarningModal_1 = __importDefault(require("@components/SecurityWarningModal"));
function ExternalLink(props) {
    var href = props.href, domain = props.domain, children = props.children, classOverride = props.classOverride;
    var data = (0, trustedDomain_1.useGetTrustedDomainQuery)(domain).data;
    var _a = __read(react_1.default.useState(false), 2), isModalOpen = _a[0], setIsModalOpen = _a[1];
    var hrefWithHttps = href.startsWith('https://') || href.startsWith('http://') || href.startsWith('mailto:') ? href : "https://".concat(href);
    if (!data || !Array.isArray(data)) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    if ((0, linkUtils_1.shouldOpenSecurityWarningModal)(hrefWithHttps, data)) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { className: "external-link ".concat(classOverride || ''), onClick: function (event) {
                    event.stopPropagation();
                    setIsModalOpen(true);
                } }, children),
            react_1.default.createElement(SecurityWarningModal_1.default, { isOpen: isModalOpen, setIsOpen: setIsModalOpen, link: hrefWithHttps })));
    }
    return (react_1.default.createElement("a", { className: "external-link ".concat(classOverride || ''), target: "_blank", href: hrefWithHttps, rel: "noreferrer" }, children));
}
exports.default = ExternalLink;
